<template>
  <div>
    <div class="content-experience-tags">
      <a
        class="content-experience-tags-item"
        :class="{ '--selected': selectedTag === undefined }"
        @click.prevent="selectedTag = undefined"
      >{{ $t("all") }}</a>
      <a
        v-for="tag in tags"
        :key="tag"
        class="content-experience-tags-item"
        :class="{ '--selected': selectedTag === tag }"
        @click.prevent="selectedTag = tag"
      >{{ tag }}</a>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  tags: string[]
}>()

const selectedTag = defineModel<string | undefined>()
</script>

<style>
.content-experience-tags {
  @apply -ml-3 -mt-3 flex flex-wrap;

  > .content-experience-tags-item {
    @apply ml-3 mt-3 rounded-md px-4 py-2 text-sm font-semibold;
    @apply cursor-pointer transition-colors duration-200 ease-in-out;
    @apply bg-gray-100 text-paragraph;
    @apply hover:bg-brand-600 hover:text-white;

    &.--selected {
      @apply bg-brand-500 text-white;
    }
  }
}
</style>
